import { render, staticRenderFns } from "./SendLackMailModal.vue?vue&type=template&id=2b5591ae&"
import script from "./SendLackMailModal.vue?vue&type=script&lang=js&"
export * from "./SendLackMailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports